import { render } from "./RechargeAgreement.vue?vue&type=template&id=3b21427a&scoped=true"
import script from "./RechargeAgreement.vue?vue&type=script&lang=js"
export * from "./RechargeAgreement.vue?vue&type=script&lang=js"

import "./RechargeAgreement.vue?vue&type=style&index=0&id=3b21427a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b21427a"]])

export default __exports__